import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details`;

export default function ServiceCustomerDetails() {
  const { id } = useParams();
  const [serviceDetails, setServiceDetails] = useState([]);
  const navigate = useNavigate();

  // Fetch service details
  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line
  }, [id]);

  const fetchDetails = () => {
    axios
      .get(`${API_URL}/${id}`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [res.data];
        setServiceDetails(data);
      })
      .catch((err) => console.error('Error fetching service:', err));
  };

  if (!serviceDetails.length) {
    return (
      <div className="container my-5 text-center">
        <p>Loading service details...</p>
      </div>
    );
  }

  return (
    <div className="container my-5">
      <Link
        to="/"
        className="btn mb-4"
        style={{
          background: '#333',
          color: '#fff',
          border: 'none',
          fontWeight: 'bold',
          borderRadius: '6px',
          padding: '10px 22px',
        }}
      >
        ← Back to Services
      </Link>
      <div className="row">
        {serviceDetails.map((service, idx) => (
          <div className="col-md-6 col-lg-4 mb-4" key={service.id || idx}>
            <div className="card shadow-lg h-100" style={{ borderRadius: '16px', overflow: 'hidden' }}>
              {service.image_url && (
                <div
                  style={{ background: '#f5f6fa', padding: '24px 24px 0 24px', cursor: 'pointer' }}
                  onClick={() => navigate(`/serviceappointments/${service.id}`)}
                  title="Book Appointment"
                >
                  <img
                    src={service.image_url}
                    alt={service.name}
                    className="img-fluid"
                    style={{
                      maxHeight: '180px',
                      objectFit: 'cover',
                      borderRadius: '12px',
                      display: 'block',
                      margin: '0 auto',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    }}
                  />
                </div>
              )}
              <div className="card-body" style={{ padding: '24px 18px' }}>
                <h3 className="card-title" style={{ color: '#4078c0', fontWeight: 700, fontSize: '1.3rem', marginBottom: '12px' }}>
                  {service.name}
                </h3>
                <p className="card-text" style={{ fontSize: '1rem', color: '#333', marginBottom: '12px' }}>
                  {service.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

